/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Schedule/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Checkbox from 'DesignSystem/Checkbox/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Schedule({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/Steps/Schedule"
  
}) {
let rulesetAllowedStepsValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'allowed_steps',
})
let constantData = 'schedule'
let aggregateData = fromAggregate.includes(rulesetAllowedStepsValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 data="ruleset.allowed_steps"
 data="'schedule'"
 aggregate="/Data/aggregate.js includes"
 isSelected={aggregateData}
 onClick={onClick}
 marginLeft={dtSpaceXxs}
 text="SCHEDULE"
/>
{children}
</React.Fragment>)
}